import { atom, useAtomValue } from 'jotai';

export const featureFlagsAtom = atom<Record<string, boolean>>({});

export const useFeatureFlagsAtomValue = () => useAtomValue(featureFlagsAtom);

export const useWinterMode = () => !!useFeatureFlagsAtomValue()?.winterMode;

export const useFacebookSSOEnabled = () => !!useFeatureFlagsAtomValue()?.facebookSSO;
